import { formatDistanceToNow } from "date-fns";
import { fr } from "date-fns/locale";
import React, { FunctionComponent } from "react";

import { useLanguage } from "../../i18n/useLanguage";

type TimeAgoProps = {
  minutes: number;
};

export const TimeAgo: FunctionComponent<TimeAgoProps> = ({ minutes }) => {
  const now = new Date();
  const past = new Date(now.getTime() - minutes * 60000);
  const [language] = useLanguage();
  return (
    <>
      {formatDistanceToNow(past, {
        addSuffix: true,
        locale: language === "fr" ? fr : undefined,
      })}
    </>
  );
};
